import { useSelector } from 'react-redux';
import { frequentQuestions } from '../utilities/questions'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Layout from './Layout';


export default function FrequentQuestions() {
    const { questions_product } = useSelector((state) => state.firstStep)

    return (
        <Layout>
            <div style={{ padding: '0px 30px', marginTop: '20px' }} >
                {
                    questions_product &&
                    frequentQuestions[questions_product]?.map(({ question, body },) => (
                        <Accordion sx={{ width: '100%', marginBottom: '10px', boxShadow: '0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)' }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
                                <Typography >
                                    {question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'Roboto', fontSize: '0.9 rem' }}>
                                    - {body}
                                </Typography>
                            </AccordionDetails>
                        </Accordion >
                    ))
                }
                {
                    frequentQuestions['generalQuestions']?.map(({ question, body },) => (
                        <Accordion sx={{ width: '100%', marginBottom: '10px' }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
                                <Typography>
                                    {question}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography variant="body2" color="text.secondary" style={{ fontFamily: 'Roboto', fontSize: '0.9 rem' }}>
                                    - {body}
                                </Typography>
                            </AccordionDetails>
                        </Accordion >
                    ))
                }
            </div>
        </Layout>
    );
}